/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIsFavouriteInput = {
  beforeEntityId?: string | null | undefined;
  entityId: string;
  isFavourite: boolean;
};
export type viewSetFavouriteMutation$variables = {
  input: JiraSetIsFavouriteInput;
};
export type viewSetFavouriteMutation$data = {
  readonly jira: {
    readonly setEntityIsFavourite: {
      readonly favouriteValue: {
        readonly id: string;
        readonly isFavourite: boolean | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type viewSetFavouriteMutation = {
  response: viewSetFavouriteMutation$data;
  variables: viewSetFavouriteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraSetIsFavouritePayload",
        "kind": "LinkedField",
        "name": "setEntityIsFavourite",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "viewSetFavouriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewSetFavouriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
    "metadata": {},
    "name": "viewSetFavouriteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "af74e48c451986374e11a5b801d5009f";

export default node;
